(function () {
  function escapeHtml(str) {
    return String(str || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  function buildHtml(items) {
    const storeLogo = "https://cdn.shopify.com/s/files/1/0954/0531/0291/files/trade-bathshack-logo.webp";
    const today = new Date().toLocaleDateString();

    let html = `<!doctype html>
<html>
<head>
  <meta charset="utf-8" />
  <title>Specification Sheets</title>
  <style>
    body { font-family: Arial, sans-serif; padding: 20px; color: rgb(21,21,21); }
    h1, h2 { text-transform: uppercase; font-weight: 300; }
    h3 {
      text-align: center;
      border-bottom: 1px solid #f1f2f3;
      width: fit-content;
      margin: 0 auto 2rem;
      padding-bottom: 1rem;
      font-weight: 400;
    }

    .sheet {
      margin-bottom: 4rem;
      padding-bottom: 3rem;
      border-bottom: 1px solid #f1f2f3;
      page-break-inside: avoid;
    }

    .product-image {
      max-width: 300px;
      margin: 0 auto 1.5rem;
      display: block;
    }

    table {
      width: 100%;
      border-collapse: collapse;
      max-width: 800px;
      margin: 0 auto 2.5rem;
    }

    th, td {
      border: 1px solid rgb(21,21,21);
      padding: 8px;
      text-align: left;
      font-size: 13px;
    }

    th {
      background-color: rgb(204,204,204);
      font-weight: 600;
      width: 40%;
    }

    .meta {
      text-align: center;
      font-size: 13px;
      margin-bottom: 1.5rem;
      color: #555;
    }

    .technical-drawing {
      margin-top: 3rem;
    }

    .technical-drawing img {
      max-width: 700px;
      width: 100%;
      margin: 0 auto;
      display: block;
    }

    #storeLogo {
      max-width: 150px;
      margin: 4rem auto 0;
      display: block;
    }
    #close-btn {
    position: fixed;
    top: 1rem;
    right: .5rem;
    height: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    }
    .actions {
      position: fixed;
      right: 1rem;
      bottom: 1rem;
      display: flex;
      gap: .75rem;
    }

    button {
      padding: 0.6rem 1rem;
      cursor: pointer;
      background: rgb(21,21,21);
      color: #fff;
      border: none;
      border-radius: .5rem;
    }

    @media print {
      .actions { display: none;}
      .product-image { max-width: 200px; }
      .technical-drawing img { max-width: 400px;}
      .technical-drawing h2, h1 {text-align: center;}
      .sheet + .sheet { break-before: page; page-break-before: always;}
      .sheet:first-of-type { break-before: auto !important; page-break-before: auto !important;}
      .per-product-grid:has(.technical-drawing) { display: grid; grid-template-columns: 1fr 1fr; grid-column-gap: 10px;}
      .technical-drawing h4, .technical-drawing h5 { text-align: center;}
    }
  </style>
</head>
<body>
<div class="title-contents">
<h1>Specification Sheets</h1>
<div class="meta">Generated: ${escapeHtml(today)}</div>
</div>
`;

    items.forEach((it) => {
      if (!it.specRows || !it.specRows.length) return;

      html += `
<section class="sheet">
  <h3>${escapeHtml(it.title)}</h3>
   ${it.image ? `<img src="${escapeHtml(it.image)}" class="product-image" alt="${escapeHtml(it.title)}" />` : ``}
  <div class="meta">SKU: ${escapeHtml(it.sku)} &nbsp;•&nbsp; Qty: ${escapeHtml(it.qty)}</div>
  <div class="per-product-grid">
  <table>
    <tbody>
`;

      it.specRows.forEach((row) => {
        if (!row.label || !row.value) return;
        html += `<tr>
          <th>${escapeHtml(row.label)}</th>
          <td>${escapeHtml(row.value)}</td>
        </tr>`;
      });

      html += `
    </tbody>
  </table>
`;

      if (it.drawing) {
        html += `
  <div class="technical-drawing">
    <h4>Technical Drawing</h4>
    <h5>${escapeHtml(it.title)}</h5>
    <img src="${escapeHtml(it.drawing)}" alt="Technical drawing" />
  </div>
`;
      }

      html += `</div></section>`;
    });

    if (storeLogo) {
      html += `<img src="${escapeHtml(storeLogo)}" alt="Store logo" id="storeLogo" />`;
    }

    html += `
<div class="actions">
  <button type="button" id="close-btn">Close</button>
  <button type="button" onclick="window.print()">🖨️ Print this page</button>
</div>
<script>
(function () {
  function closeSmart() {
    window.close();
    setTimeout(function () {
      if (history.length > 1) history.back();
    }, 100);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest('#close-btn');
    if (btn) { e.preventDefault(); closeSmart(); }
  });
})();
<\/script>

</body>
</html>`;

    return html;
  }

  function downloadHtml(filename, html) {
    const blob = new Blob([html], { type: "text/html" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-cart-specs-sheet-btn]");
    if (!btn) return;

    const items = window.__cartSpecsItems || [];
    const hasAny = items.some(i => i.specRows && i.specRows.length);

    if (!hasAny) {
      alert("No specs found for items in cart.");
      return;
    }

    const html = buildHtml(items);
    const mode = btn.getAttribute("data-mode") || "new_tab";

    if (mode === "download") {
      downloadHtml("cart-specification-sheets.html", html);
    } else {
      const w = window.open();
      if (!w) {
        alert("Popup blocked. Please allow popups.");
        return;
      }
      w.document.write(html);
      w.document.close();
    }
  });
})();
